<ng-content select="[palantir-page-header], palantir-page-header" />
<ng-content select="[palantir-page-content], palantir-page-content" />
<ng-content select="[palantir-page-bulk-actions], palantir-page-bulk-actions" />
<ng-content select="[palantir-page-footer], palantir-page-footer" />
